import { PortfolioSection } from "./components/PortfolioSection";
import { SupportCard } from "./components/SupportCard";
import { WalletCard } from "./components/WalletCard";

export function DashboardPage() {
  return (
    <div className="grid grid-cols-1 gap-4 p-4 sm:p-6 md:grid-cols-3">
      <WalletCard />

      <div className="md:col-span-2">
        <PortfolioSection />
      </div>

      <div className="md:col-span-2">
        <SupportCard />
      </div>
    </div>
  );
}
